import { Component, Inject, OnInit } from '@angular/core';
import { SOPO_DIALOG_DATA, SopoDialogRef, SopoDialogSettings } from '../../interfaces/dialog';
import { SopoConfirmData } from '../../interfaces/confirm';

export class SopoDepositFeeSettings extends SopoDialogSettings {
    data?: SopoDepositFeeDataInput;
}
export interface SopoDepositFeeDataInput {
    header?: string;
    body?: string;
    okText?: string;
    cancelText?: string;
}

@Component({
    selector: 'app-sopo-deposit-fee',
    templateUrl: './sopo-deposit-fee.component.html',
    styleUrls: ['./sopo-deposit-fee.component.scss'],
    standalone: false,
})
export class SopoDepositFeeComponent implements OnInit {
    header: string = 'Deposit Fee Disclaimer';
    subHeader: string = 'AVOID DEPOSIT FEES!';
    body: string = 'We recommend purchasing the Gold + Free Bonus Sweeps Coins packages directly within the shop thru in-app purchases.';
    okText: string = 'PROCEED TO DEPOSIT';
    cancelText: string = 'TAKE ME TO THE SHOP';

    shopWrapper = {
        titleNumber: "5K",
        titleType: "gold",
        bonusNumber: "5",
        bonusType: "sweepstakes",
        price: "$4.99",
    }

    constructor(
        @Inject(SOPO_DIALOG_DATA) data: SopoConfirmData,
        private sopoDialogRef: SopoDialogRef,
    ) { }

    ngOnInit() { }

    close(answer: boolean) {
        this.sopoDialogRef.close(answer);
    }

}
